import CancellableHelper from "../CancellableHelper";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { FILTER_NAMES } from "@/static/filterNames";
import { AutomaticReportAdd, AutomaticReportEdit, AutomaticReportResponse } from "@/models/api/report/AutomaticReport";
import { SelectItem } from "@/models/api/SelectItem";

export const URL_GET_AUTOMATIC_REPORTS = "/Report/GetAutomaticReports";
export const URL_POST_CREATE_AUTOMATIC_REPORT = "/Report/CreateAutomaticReport";
export const URL_POST_EDIT_AUTOMATIC_REPORT = "/Report/EditAutomaticReport";
export const URL_POST_DELETE_AUTOMATIC_REPORT = "/Report/DeleteAutomaticReport/${ScheduleId}";
export const URL_POST_GET_EMAIL_ADDRESSES_TO_SEND_REPORT = "/Report/EmailAddresses";

const _getAutomaticReports = new CancellableHelper<AutomaticReportResponse>(
  URL_GET_AUTOMATIC_REPORTS,
  AutomaticReportResponse
);
export const getAutomaticReports = async (
  reportType: number,
  page: number,
  count: number
): Promise<AutomaticReportResponse> => {
  return await _getAutomaticReports.get({
    reportType: reportType,
    page: page,
    count: count,
  });
};

const _createAutomaticReport = new CancellableHelper<void>(URL_POST_CREATE_AUTOMATIC_REPORT, null, true);
_createAutomaticReport.jsonSerializer = true;
export const createAutomaticReport = async (
  criterions: Array<CriterionItemRequest> | null,
  filterName: FILTER_NAMES,
  automaticReportAdd: AutomaticReportAdd
): Promise<void> => {
  await _createAutomaticReport.post(
    {
      Criterions: criterions,
      FilterName: filterName,
    },
    automaticReportAdd
  );
};

const _editAutomaticReport = new CancellableHelper<void>(URL_POST_EDIT_AUTOMATIC_REPORT, null, true);
_editAutomaticReport.jsonSerializer = true;
export const editAutomaticReport = async (
  criterions: Array<CriterionItemRequest> | null,
  filterName: FILTER_NAMES,
  automaticReportEdit: AutomaticReportEdit
): Promise<void> => {
  await _editAutomaticReport.post(
    {
      Criterions: criterions,
      FilterName: filterName,
    },
    automaticReportEdit
  );
};

const _deleteAutomaticReport = new CancellableHelper<void>(URL_POST_DELETE_AUTOMATIC_REPORT, null, true);
export const deleteAutomaticReport = async (scheduleId: number): Promise<void> => {
  await _deleteAutomaticReport.post({ ScheduleId: scheduleId }, null);
};

const _getEmailAddressesToSendReport = new CancellableHelper<Array<SelectItem>>(
  URL_POST_GET_EMAIL_ADDRESSES_TO_SEND_REPORT
);
export const getEmailAddressesToSendReport = async (): Promise<Array<SelectItem>> => {
  return await _getEmailAddressesToSendReport.post({}, null);
};
